import React, { Component ,lazy,Suspense} from 'react';
/*

import Rpsword from './pages/Rpsword';
import Singup from './pages/Singup';
import Admin from './pages/Admin';
import User from './pages/User';
import NotFound from './pages/NotFound';
*/
import {
  Routes,
  Route,
} from 'react-router-dom'
import Tang from './pages/Tang';
import NotFound from './pages/NotFound'
import Loading from './components/Loading';


const Gridlock = lazy(()=> import('./pages/Gridlock'))
//const NotFound= lazGy(()=> import('./pages/NotFound'))
const EarthTrek = lazy(()=> import('./pages/EarthTrek'))

const Humanbody = lazy(()=> import('./pages/Humanbody'))

const LAM = lazy(()=> import('./pages/LAM'))

export default class App extends Component {
  render() {
    return <div>
      <Suspense fallback={<Loading/>}>
      <Routes>
      
        <Route index element = {<Tang/>}/> 
        <Route path="/tang/*" element = {<Tang/>}/>
        <Route path="/gridlock/*" element = {< Gridlock />}/>
        <Route path="/earthtrek/*" element = {< EarthTrek />}/>
        <Route path="/humanbody/*" element = {< Humanbody />}/>
        <Route path="/lam/*" element = {< LAM />}/>
        <Route path="*" element={<NotFound />} />

      </Routes>
      </Suspense>
    </div>;
  }
}
